module.exports = __webpack_public_path__ + "img/image7.3be14e1a.png";